import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { HeartCrack, Users, Coins, Flame, BatteryWarning, Home, Briefcase, ShieldAlert, Compass } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
export function Problems() {
  const problems = [{
    icon: HeartCrack,
    text: 'Problemas amorosos que se repiten constantemente'
  }, {
    icon: Users,
    text: 'Conflictos familiares sin solución aparente'
  }, {
    icon: Coins,
    text: 'Sensación de bloqueo económico'
  }, {
    icon: Flame,
    text: 'Mala suerte persistente'
  }, {
    icon: BatteryWarning,
    text: 'Cansancio emocional o energético'
  }, {
    icon: Home,
    text: 'Ambientes cargados dentro del hogar'
  }, {
    icon: Briefcase,
    text: 'Negocios que no prosperan'
  }, {
    icon: ShieldAlert,
    text: 'Sensación de energías negativas'
  }, {
    icon: Compass,
    text: 'Falta de claridad para tomar decisiones importantes'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-170">
      <div className="max-w-7xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-173">
            ¿Te identificas con alguna de{' '}
            <span className="text-gradient-gold" data-id="element-174">estas situaciones?</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-175">
          {problems.map((problem, index) => <motion.div key={index} variants={cardVariants} className="glass-panel p-6 rounded-2xl flex flex-col items-center text-center group hover:bg-mystic-blue-800/50 transition-colors duration-300" data-id="element-176">
              <div className="w-14 h-14 rounded-full bg-mystic-gold/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-177">
                <problem.icon className="w-7 h-7 text-mystic-gold" data-id="element-178" />
              </div>
              <p className="text-mystic-white/90 font-medium" data-id="element-179">{problem.text}</p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-3xl mx-auto text-center" data-id="element-180">
          <p className="text-lg text-mystic-white/80 mb-8 font-light" data-id="element-181">
            Muchas veces existen factores energéticos que no vemos, pero que
            pueden influir profundamente en nuestro bienestar y nuestras
            oportunidades.
          </p>
          <WhatsAppButton text="Quiero recibir orientación" variant="primary" message="Hola Maestro Navy, me identifico con algunas de las situaciones mencionadas y quiero recibir orientación." data-id="element-182" />
        </motion.div>
      </div>
    </section>;
}